import axios from 'axios';
import config from '.././Config';
import { changePassword } from '../types/ChangePassword';
import { recoveryQuestionAnswer } from '../types/RecoveryQuestionAnswer';

const getHeaders = (token: string) => {
    const header: any = {
        accept: 'application/json',
        contentType: 'application/json',
        token: token,
        client_id: config.oidc.clientId,
    };
    return header;
};

const getQuestions = async (uid: string, token: string) => {
    var result = await axios.request({
        method: 'GET',
        baseURL: config.userApi.config.baseUrl,
        url: uid + config.userApi.recoveryQuestions,
        headers: getHeaders(token),
    });

    return result;
};

const saveQuestion = async (uid: string, data: recoveryQuestionAnswer, token: string) => {
    data.uId = uid;
    var url = config.userApi.changeRecoveryQuestion;
    var axconfig = { baseURL: config.userApi.config.baseUrl, headers: getHeaders(token) };
    var response = await axios.post(url, data, axconfig);
    return response;
};

const changePwd = async (uid: string, data: changePassword, token: string) => {
    data.uId = uid;
    var url = config.userApi.changePassword;
    var axconfig = { baseURL: config.userApi.config.baseUrl, headers: getHeaders(token) };

    var response = await axios.post(url, data, axconfig);
    return response;
};

export default {
    getQuestions,
    saveQuestion,
    changePwd,
};
